"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_helmet_1 = require("react-helmet");
var clsx_1 = __importDefault(require("clsx"));
var core_1 = require("@material-ui/core");
var ld_1 = require("../utils/ld");
var useStyles = core_1.makeStyles(function (theme) { return ({
    root: {
        justifyContent: 'center',
        flexWrap: 'wrap'
    },
    paper: {
        padding: theme.spacing() + "px " + theme.spacing(2) + "px"
    }
}); });
exports.Breadcrumb = function (_a) {
    var url = _a.url, current = _a.current, hierarchies = _a.hierarchies, onLinkClick = _a.onLinkClick;
    var classes = useStyles();
    var links = __spreadArrays([
        { title: 'よくあるご質問', link: '/' }
    ], (hierarchies || []).filter(function (_a) {
        var title = _a.title;
        return title;
    }).map(function (link) { return (__assign(__assign({}, link), { link: link.link || '/' })); }), [
        { title: current, link: '' }
    ]);
    return (react_1.default.createElement("div", { className: clsx_1.default('faq-breadcrumb', classes.paper) },
        react_1.default.createElement(react_helmet_1.Helmet, null,
            react_1.default.createElement("script", { type: "application/ld+json" }, JSON.stringify(ld_1.breadcrumb(url, links)))),
        react_1.default.createElement(core_1.Breadcrumbs, { "arial-label": "Breadcrumb", separator: '>', maxItems: 5 }, links.map(function (_a, index) {
            var title = _a.title, link = _a.link;
            var handleClick = function (e) {
                e.preventDefault();
                if (onLinkClick && link) {
                    var options = index === 0 ? {} : { state: { hierarchies: links.slice(1, index) } };
                    onLinkClick(link, options);
                }
            };
            return link ? (react_1.default.createElement(core_1.Link, { key: link, color: "inherit", href: "#", onClick: handleClick }, title)) : (react_1.default.createElement(core_1.Typography, { key: link, color: "textPrimary" }, title));
        }))));
};
//# sourceMappingURL=Breadcrumb.js.map